// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'
import router from './Router'
import store from './Store'
import GetTextPlugin from 'vue-gettext'
import translations from '../static/locale/translation.json'

Vue.use(GetTextPlugin, {
  availableLanguages: {
    en_US: 'English',
    fr_FR: 'Français',
    de_DE: 'Deutsch'
  },
  defaultLanguage: 'fr_FR',
  translations: translations,
  silent: false
})

console.log('process.env.NODE_ENV:', process.env.NODE_ENV)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
  router,
  store
})



// WEBPACK FOOTER //
// ./src/main.js